import { IDropdownOption, P2GDropdown } from '@parcel2go/core-ui';
import QuoteFilterSection from './quote-filter-section';

function FilterDropDown({
  title,
  label,
  options,
  selected,
  onChange,
  dataTestId
}: {
  title?: string;
  label?: string;
  options: IDropdownOption[];
  selected: string | undefined;
  onChange: (value: string) => void;
  dataTestId?: string;
}) {
  return (
    <QuoteFilterSection title={title} dataTestId={dataTestId}>
      <P2GDropdown
        options={options}
        onChange={(value) => onChange(value as string)}
        id={label ?? title ?? ''}
        value={selected || ''}
      />
    </QuoteFilterSection>
  );
}

export default FilterDropDown;
